module.exports = __webpack_public_path__ + "img/oncology_palliative_care.fc860acf.svg";